/* eslint-disable*/
import React, { useEffect, useState } from 'react';
import ReactModal from 'react-modal';
import {
  DependentApproveButtonGroup,
  DependentApproveToolTip,
  DependentsApprovalButtons,
  DependentsApprovalCollapsable,
  DependentsApprovalCollapsableLeft,
  DependentsApprovalCollapsableRight,
  DependentsApprovalCollapsableRightEyeClosedIcon,
  DependentsApprovalCollapsableRightEyeIcon,
  DependentsApprovalCollapsableRightIcon,
  DependentsApprovalCollapsableRightIconUp,
  DependentsApprovalCollapsableTitle,
  DependentsApprovalCollapseActive,
  DependentsApprovalCollapseActiveFirstRow,
  DependentsApprovalCollapseActiveFourthRow,
  DependentsApprovalCollapseActiveLargeInput,
  DependentsApprovalCollapseActiveNormalInput,
  DependentsApprovalCollapseActiveSecondRow,
  DependentsApprovalCollapseActiveThirdRow,
  DependentsApprovalCollapseApproveButton,
  DependentsApprovalCollapseDeclineButton,
  DependentsApprovalContainer,
  DependentsApprovalContent,
  DependentsApprovalHeader,
  DependentsApprovalTitle,
  DependentsApprovalTitleComponent,
} from './styles';
import { AlertAdapter, RegularButton } from 'pg-ui-library';
import { IChangeDetails } from 'src/interfaces';
import { useMutation } from '@tanstack/react-query';
import ApprovalsService from 'src/services/approvals.service';
import { CloseIcon } from '../reset-password-modal/styles';
import closeSvg from 'src/assets/close.svg';
import { formatDateConverter } from 'src/utils/formatDateConvert';

export const DependentsApprovalModal: React.FC<{
  isOpen: boolean;
  setIsOpen: any;
  selectedDependent: any;
}> = ({ isOpen, setIsOpen, selectedDependent }) => {
  const [aciveCard, setActiveCard] = useState<boolean>(false);
  const [oldValues, setOldValues] = useState<boolean>(false);
  const [tooltip, setTooltip] = useState<boolean>(false);
  const handleModalClose = () => {
    setIsOpen(false);
  };

  const handleOldValues = () => {
    setOldValues(!oldValues);
  };

  const mutation = useMutation(
    async (variables: { requestId: string; status: string }) => {
      await ApprovalsService.reviewDependentChanges(variables);
    },
    {
      onSuccess: () => {
        AlertAdapter('Review sent!', 'success');
        setIsOpen(false);
      },
      onError: () => {
        AlertAdapter('Fail on sending the review!', 'error');
      },
    }
  );

  return (
    <>
      <ReactModal
        isOpen={isOpen}
        ariaHideApp={false}
        style={{
          overlay: {
            margin: 'auto',
            backgroundColor: 'rgba(0, 0, 0, 0.6)',
          },
          content: {
            borderRadius: '10px',
            margin: 'auto',
            width: '1190px',
            height: '640px',
            display: 'flex',
            flexDirection: 'column',
            background: '#E4E4EB',
          },
        }}
        onRequestClose={handleModalClose}
      >
        <DependentsApprovalContainer>
          <DependentsApprovalHeader>
            <DependentsApprovalTitleComponent>
              <DependentsApprovalTitle>Dependent Approval</DependentsApprovalTitle>
            </DependentsApprovalTitleComponent>
            <DependentsApprovalButtons>
              <CloseIcon src={closeSvg} onClick={() => setIsOpen(false)} />
            </DependentsApprovalButtons>
          </DependentsApprovalHeader>
          <DependentsApprovalContent>
            <div>
              <DependentsApprovalCollapsable>
                <DependentsApprovalCollapsableLeft>
                  <DependentsApprovalCollapsableTitle>{`
                        ${selectedDependent?.changeDetails[2]?.newValue} ${selectedDependent?.changeDetails[3]?.newValue} ${selectedDependent?.changeDetails[4]?.newValue}`}</DependentsApprovalCollapsableTitle>
                </DependentsApprovalCollapsableLeft>
                <DependentsApprovalCollapsableRight>
                  {aciveCard ? (
                    <DependentApproveToolTip style={{ visibility: tooltip ? 'visible' : 'hidden' }}>
                      {oldValues ? 'Previous values' : 'Incoming values'}
                    </DependentApproveToolTip>
                  ) : (
                    ''
                  )}
                  {aciveCard ? (
                    <div>
                      {oldValues ? (
                        <DependentsApprovalCollapsableRightEyeClosedIcon
                          onMouseEnter={() => setTooltip(true)}
                          onMouseLeave={() => setTooltip(false)}
                          onClick={() => handleOldValues()}
                        />
                      ) : (
                        <DependentsApprovalCollapsableRightEyeIcon
                          onMouseEnter={() => setTooltip(true)}
                          onMouseLeave={() => setTooltip(false)}
                          onClick={() => handleOldValues()}
                        />
                      )}
                      <DependentsApprovalCollapsableRightIconUp
                        onClick={() => setActiveCard(!aciveCard)}
                        color="#fff"
                      />
                    </div>
                  ) : (
                    <DependentsApprovalCollapsableRightIcon onClick={() => setActiveCard(!aciveCard)} color="#fff" />
                  )}
                </DependentsApprovalCollapsableRight>
              </DependentsApprovalCollapsable>
              <DependentsApprovalCollapseActive style={{ visibility: aciveCard ? 'visible' : 'hidden' }}>
                <DependentsApprovalCollapseActiveFirstRow>
                  <DependentsApprovalCollapseActiveLargeInput
                    readOnly
                    style={{ background: oldValues ? '#9D9DC4' : 'white', color: oldValues ? 'white' : 'black' }}
                    value={
                      selectedDependent?.changeDetails
                        .filter((dependent: IChangeDetails) => dependent.field === 'firstName')
                        .map((dependent: IChangeDetails) => (oldValues ? dependent.oldValue : dependent.newValue))
                        .join(', ') +
                      ' ' +
                      selectedDependent?.changeDetails
                        .filter((dependent: IChangeDetails) => dependent.field === 'middleName')
                        .map((dependent: IChangeDetails) => (oldValues ? dependent.oldValue : dependent.newValue))
                        .join(', ') +
                      ' ' +
                      selectedDependent?.changeDetails
                        .filter((dependent: IChangeDetails) => dependent.field === 'lastName')
                        .map((dependent: IChangeDetails) => (oldValues ? dependent.oldValue : dependent.newValue))
                        .join(', ')
                    }
                    label="Name"
                  />
                  <DependentsApprovalCollapseActiveNormalInput
                    readOnly
                    style={{ background: oldValues ? '#9D9DC4' : 'white', color: oldValues ? 'white' : 'black' }}
                    value={selectedDependent?.changeDetails
                      .filter((dependent: IChangeDetails) => dependent.field === 'relationshipType')
                      .map((dependent: IChangeDetails) => (oldValues ? dependent.oldValue : dependent.newValue))
                      .join(', ')}
                    label="Relationship"
                  />
                  <DependentsApprovalCollapseActiveNormalInput
                    readOnly
                    style={{ background: oldValues ? '#9D9DC4' : 'white', color: oldValues ? 'white' : 'black' }}
                    value={selectedDependent?.changeDetails
                      .filter((dependent: IChangeDetails) => dependent.field === 'ssn')
                      .map((dependent: IChangeDetails) => (oldValues ? dependent.oldValue : dependent.newValue))
                      .join(', ')}
                    label="SSN"
                  />
                  <DependentsApprovalCollapseActiveNormalInput
                    readOnly
                    style={{ background: oldValues ? '#9D9DC4' : 'white', color: oldValues ? 'white' : 'black' }}
                    value={selectedDependent?.changeDetails
                      .filter((dependent: IChangeDetails) => dependent.field === 'address')
                      .map((dependent: IChangeDetails) => (oldValues ? dependent.oldValue : dependent.newValue))
                      .join(', ')}
                    label="Adress"
                  />
                </DependentsApprovalCollapseActiveFirstRow>
                <DependentsApprovalCollapseActiveSecondRow>
                  <DependentsApprovalCollapseActiveNormalInput
                    readOnly
                    style={{ background: oldValues ? '#9D9DC4' : 'white', color: oldValues ? 'white' : 'black' }}
                    value={selectedDependent?.changeDetails
                      .filter((dependent: IChangeDetails) => dependent.field === 'birthDate')
                      .map((dependent: IChangeDetails) => {
                        return oldValues
                          ? formatDateConverter(dependent.oldValue)
                          : formatDateConverter(dependent.newValue);
                      })
                      .join(', ')}
                    label="Birth Date"
                  />
                  <DependentsApprovalCollapseActiveNormalInput
                    readOnly
                    style={{ background: oldValues ? '#9D9DC4' : 'white', color: oldValues ? 'white' : 'black' }}
                    value={selectedDependent?.changeDetails
                      .filter((dependent: IChangeDetails) => dependent.field === 'city')
                      .map((dependent: IChangeDetails) => (oldValues ? dependent.oldValue : dependent.newValue))
                      .join(', ')}
                    label="City"
                  />
                  <DependentsApprovalCollapseActiveNormalInput
                    readOnly
                    style={{ background: oldValues ? '#9D9DC4' : 'white', color: oldValues ? 'white' : 'black' }}
                    value={selectedDependent?.changeDetails
                      .filter((dependent: IChangeDetails) => dependent.field === 'state')
                      .map((dependent: IChangeDetails) => (oldValues ? dependent.oldValue : dependent.newValue))
                      .join(', ')}
                    label="State"
                  />
                  <DependentsApprovalCollapseActiveNormalInput
                    readOnly
                    style={{ background: oldValues ? '#9D9DC4' : 'white', color: oldValues ? 'white' : 'black' }}
                    value={selectedDependent?.changeDetails
                      .filter((dependent: IChangeDetails) => dependent.field === 'zipCode')
                      .map((dependent: IChangeDetails) => (oldValues ? dependent.oldValue : dependent.newValue))
                      .join(', ')}
                    label="Zip Code"
                  />
                  <DependentsApprovalCollapseActiveNormalInput
                    readOnly
                    style={{ background: oldValues ? '#9D9DC4' : 'white', color: oldValues ? 'white' : 'black' }}
                    value={selectedDependent?.changeDetails
                      .filter((dependent: IChangeDetails) => dependent.field === 'county')
                      .map((dependent: IChangeDetails) => (oldValues ? dependent.oldValue : dependent.newValue))
                      .join(', ')}
                    label="County"
                  />
                </DependentsApprovalCollapseActiveSecondRow>
                <DependentsApprovalCollapseActiveThirdRow>
                  <DependentsApprovalCollapseActiveNormalInput
                    readOnly
                    style={{ background: oldValues ? '#9D9DC4' : 'white', color: oldValues ? 'white' : 'black' }}
                    value={selectedDependent?.changeDetails
                      .filter((dependent: IChangeDetails) => dependent.field === 'country')
                      .map((dependent: IChangeDetails) => (oldValues ? dependent.oldValue : dependent.newValue))
                      .join(', ')}
                    label="Country"
                  />
                  <DependentsApprovalCollapseActiveNormalInput
                    readOnly
                    style={{ background: oldValues ? '#9D9DC4' : 'white', color: oldValues ? 'white' : 'black' }}
                    value={selectedDependent?.changeDetails
                      .filter((dependent: IChangeDetails) => dependent.field === 'gender')
                      .map((dependent: IChangeDetails) => (oldValues ? dependent.oldValue : dependent.newValue))
                      .join(', ')}
                    label="Gender"
                  />
                  <DependentsApprovalCollapseActiveNormalInput
                    readOnly
                    value={selectedDependent?.changeDetails
                      .filter((dependent: IChangeDetails) => dependent.field === 'smoker')
                      .map((dependent: IChangeDetails) => (oldValues ? dependent.oldValue : dependent.newValue))
                      .join(', ')}
                    style={{ background: oldValues ? '#9D9DC4' : 'white', color: oldValues ? 'white' : 'black' }}
                    label="Smoker Status"
                  />
                  <DependentsApprovalCollapseActiveNormalInput
                    readOnly
                    value={selectedDependent?.changeDetails
                      .filter((dependent: IChangeDetails) => dependent.field === 'homePhone')
                      .map((dependent: IChangeDetails) => (oldValues ? dependent.oldValue : dependent.newValue))
                      .join(', ')}
                    style={{ background: oldValues ? '#9D9DC4' : 'white', color: oldValues ? 'white' : 'black' }}
                    label="Home Phone"
                  />
                  <DependentsApprovalCollapseActiveNormalInput
                    readOnly
                    value={selectedDependent?.changeDetails
                      .filter((dependent: IChangeDetails) => dependent.field === 'workPhone')
                      .map((dependent: IChangeDetails) => (oldValues ? dependent.oldValue : dependent.newValue))
                      .join(', ')}
                    style={{ background: oldValues ? '#9D9DC4' : 'white', color: oldValues ? 'white' : 'black' }}
                    label="Work Phone"
                  />
                </DependentsApprovalCollapseActiveThirdRow>
                <DependentsApprovalCollapseActiveFourthRow>
                  <DependentsApprovalCollapseActiveLargeInput
                    readOnly
                    style={{ background: oldValues ? '#9D9DC4' : 'white', color: oldValues ? 'white' : 'black' }}
                    value={selectedDependent?.changeDetails
                      .filter((dependent: IChangeDetails) => dependent.field === 'email')
                      .map((dependent: IChangeDetails) => (oldValues ? dependent.oldValue : dependent.newValue))
                      .join(', ')}
                    label="Email"
                  />
                  <DependentsApprovalCollapseActiveNormalInput
                    readOnly
                    value={selectedDependent?.changeDetails
                      .filter((dependent: IChangeDetails) => dependent.field === 'student')
                      .map((dependent: IChangeDetails) => (oldValues ? dependent.oldValue : dependent.newValue))
                      .join(', ')}
                    style={{
                      marginLeft: '15px',
                      background: oldValues ? '#9D9DC4' : 'white',
                      color: oldValues ? 'white' : 'black',
                    }}
                    label="Student Status"
                  />
                  <DependentApproveButtonGroup>
                    <div>
                      <DependentsApprovalCollapseDeclineButton
                        disabled={
                          mutation.isLoading || (selectedDependent && selectedDependent.requestStatus === 'APPROVED')
                        }
                        onClick={() => {
                          mutation.mutate({ requestId: selectedDependent.id, status: 'DENIED' });
                        }}
                      >
                        DECLINE
                      </DependentsApprovalCollapseDeclineButton>
                    </div>
                    <div>
                      <DependentsApprovalCollapseApproveButton
                        disabled={
                          mutation.isLoading || (selectedDependent && selectedDependent.requestStatus === 'APPROVED')
                        }
                        onClick={() => {
                          mutation.mutate({ requestId: selectedDependent.id, status: 'APPROVED' });
                        }}
                      >
                        APPROVE
                      </DependentsApprovalCollapseApproveButton>
                    </div>
                  </DependentApproveButtonGroup>
                </DependentsApprovalCollapseActiveFourthRow>
              </DependentsApprovalCollapseActive>
            </div>
          </DependentsApprovalContent>
        </DependentsApprovalContainer>
      </ReactModal>
    </>
  );
};
